<div class="print-container">
    <h1 class="page-label">Bulk Print</h1>
</div>

<div class="tab-pane">
    <div>
        <div class="print-container">
            <div class="row">
                <label class="col-sm-3 input-label" for="portal-input">CSV File:</label>
                <div class="col-sm-9">
                    <div class="row">
                        <input class="col-sm-8 form-control" type="text" [ngModel]="selectedFile?.name" [readonly] [disabled] />

                        <button class="btn btn-ef col-sm-4" type="button" (click)="selectFileClicked()" [disabled]="isPrinting">Select CSV File</button>
                        <input type="file" #csvFile (change)="onSelectedFileChanged($event)" style="display:none" accept=".csv"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="col-sm-3 input-label" for="portal-input">Printer:</label>
                <div class="printer-input col-sm-9">
                    <div class="row">
                        <select class="form-control" [(ngModel)]="selectedPrinter" [disabled]="isPrinting || isLoadingPrinters">
                            <option [ngValue]="null"> -- Choose Printer -- </option>
                            <option *ngFor="let printer of availablePrinters; index as i" [ngValue]="printer">{{printer}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="printFileClicked()" class="submit btn btn-primary col-sm-3" [disabled]="this.isPrinting || this.selectedFile == null || this.selectedPrinter == null" >Print File</button>
    </div>
    <div *ngIf="printStatus != null" class="row">
        <h3 [class.api-result-error]="printStatus == 'error'" [class.api-result-success]="printStatus == 'success'" [class.api-result-pending]="printStatus == 'pending'">
            {{ printMessage }}
        </h3>
    </div>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>